/*
 #*===================================================================
 #*
 #* Licensed Materials - Property of GameTimeFootage Inc.
 #*
 #* Copyright NextPro 2018. All Rights Reserved.
 #*
 #*===================================================================
 */

import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { Store } from '@ngrx/store';
import { Observable, of, throwError as _throw } from 'rxjs';
import { catchError, switchMap, take, tap } from 'rxjs/operators';

import * as fromStore from 'app/shared/store';
import { UserDataService } from 'app/shared/services/user-data.service';
import { GuardHelper } from 'app/shared/guards/guard-helper';

@Injectable()
export class UserGuard implements CanActivate {
  constructor(
    private guardHelper: GuardHelper,
    private router: Router,
    private store: Store<fromStore.SharedState>,
    private userDataService: UserDataService
  ) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    return this.guardHelper.checkStore().pipe(
      switchMap((success) => {
        if (!success || success === 'Invalid token') {
          return _throw(new Error('Failed to Validate Token'));
        }
        if (success?.id) {
          this.store
            .select(fromStore.getUserNewVideosState)
            .pipe(
              take(1),
              tap((newVideosState) => {
                if (!newVideosState.loading && !newVideosState.success) {
                  this.store.dispatch(new fromStore.LoadUserNewVideos(success.id));
                }
              })
            )
            .subscribe();
        }
        return of(true);
      }),
      catchError(() => {
        // delete tokens from localstorage and cookie jar
        this.userDataService.logout().subscribe();

        // set message on login page
        this.store.dispatch(new fromStore.UserLoginFail('Session Expired'));

        // go to login page
        this.router.navigate(['/login'], { queryParams: { returnUrl: state.url } });

        return of(false);
      })
    );
  }
}
